import tippy, { animateFill } from 'tippy.js';

import hook from '../../scripts/utilities/hook';

const TOOLTIP_SELECTOR = hook('js-tooltip');

const tooltips = document.querySelectorAll(TOOLTIP_SELECTOR);

document.addEventListener('DOMContentLoaded', () => {
  tooltips.forEach(tooltip => {
    // eslint-disable-next-line no-unused-vars
    const newTippy = tippy(tooltip, {
      content: 'Tooltip',
      animateFill: true,
      plugins: [animateFill],
      offset: [0, 4],
      allowHTML: true,
      placement: 'bottom',
    });
  });
});
